import React, { useState } from 'react';
import { EyeIcon } from '@/components/contextActions/icons';
import { HeaderIconButton } from '@/components/contextActions/common';
import { useImageViewer } from '@/components/imageViewer';
import { useCompleteReport } from './useCompleteReport';

export const ViewReportButton = () => {
  const { generate, isLoading: isGenerating } = useCompleteReport();
  const { openViewer } = useImageViewer();
  const [clicked, setClicked] = useState(false);

  const onView = async () => {
    setClicked(true);
    const medium = await generate();
    if (medium) {
      openViewer({ openToIndex: 0, images: [medium] });
    }
  };

  if (!isGenerating && clicked) {
    setClicked(false);
  }

  const isLoading = isGenerating && clicked;

  return (
    <HeaderIconButton
      disabled={isGenerating}
      loading={isLoading}
      icon={<EyeIcon />}
      onClick={onView}
    />
  );
};
